// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manuals-wrapper {
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.manuals-wrapper .search-bar-wrapper {
  background-color: var(--background-color);
  padding: 30px 0;
  right: 50%;
  left: 50%;
  display: flex;
  text-align: center;
}
.manuals-wrapper .search-bar-wrapper .search-bar-components {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 30px auto;
}
.manuals-wrapper .search-bar-wrapper .search-bar-components .rich-text__heading {
  margin: 0;
  padding: 20px 0 0 0;
}
.manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code {
  margin: 0;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code {
    margin: 0 25px;
  }
}
.manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper {
  display: flex;
  flex-direction: row;
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper {
    flex-direction: column;
  }
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper button {
    width: 50%;
    margin: 20px auto;
  }
}
.manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper input {
  padding: 16px;
  height: 50px;
  background: transparent;
  font-size: 16px;
  width: 300px;
  margin-right: 10px;
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper input {
    margin: 0;
    width: 100%;
  }
}
.manuals-wrapper .manuals-container {
  padding: 12px 0 0;
  display: flex;
  gap: 36px;
}
@media (min-width: 551px) and (max-width: 768px) {
  .manuals-wrapper .manuals-container {
    gap: 16px !important;
    align-items: center;
  }
}
@media (max-width: 1350px) {
  .manuals-wrapper .manuals-container {
    gap: 24px !important;
  }
  .manuals-wrapper .search-bar-wrapper .search-bar-components {
    margin: 30px auto 0;
  }
}
@media only screen and (max-width: 768px) {
  .manuals-wrapper .manuals-container {
    flex-direction: column !important;
    align-items: center;
  }
  .manuals-wrapper .manuals-container button {
    margin: 0 auto;
  }
  .manuals-wrapper .manuals-header {
    padding: 0 25px !important;
  }
  .manuals-wrapper .manuals-wrapper .search-bar-wrapper {
    padding: 24px 40px !important;
  }
}
.manuals-wrapper #searchBar {
  width: 350px;
  height: 50px;
}
.manuals-wrapper .table-container {
  margin: 0 auto;
  width: min-content;
  padding: 50px 0px;
}
.manuals-wrapper .table-container .manuals-text-description {
  text-align: left;
  height: 24px;
}
.manuals-wrapper .table-container table {
  width: 100%;
  font-weight: 500;
  border-collapse: collapse;
}
.manuals-wrapper .table-container table th,
.manuals-wrapper .table-container table td {
  padding: 12px 16px;
  border: 1px solid #e6e6e6;
}
.manuals-wrapper .table-container table thead {
  background-color: #f0f0f0;
}
.manuals-wrapper .table-container table tbody tr {
  transition: opacity 0.5s ease;
  opacity: 1;
}
.manuals-wrapper .table-container table tbody tr.hidden {
  opacity: 0;
  display: none;
  height: 0;
  overflow: hidden;
}
.manuals-wrapper .table-container table tbody th {
  text-align: left;
}
.manuals-wrapper .table-container table tbody td .manual-wrapper {
  padding-bottom: 7px;
}
.manuals-wrapper .table-container table tbody td .manual-wrapper a {
  color: #193c72;
  text-decoration: underline;
}
.manuals-wrapper .table-container table tbody td .manual-wrapper:last-child {
  padding-bottom: 0;
}
.manuals-wrapper .table-container table tbody td .manual-button {
  width: 100%;
}
.manuals-wrapper .table-container .no-item {
  margin: auto;
  padding: 1.5rem;
  border: 1px solid #e6e6e6;
  text-align: center;
  min-width: 980px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.manuals-wrapper .table-container .no-item ul {
  width: fit-content;
  margin: 1.5rem 0 0;
}
.manuals-wrapper .table-container .no-item li {
  width: fit-content;
}
.manuals-wrapper .table-container .archived-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
}
.manuals-wrapper .table-container .archived-image {
  max-height: 40px;
  display: block;
  margin-top: 5px;
  margin-right: 15px;
}
.manuals-wrapper .table-container .manual-button {
  min-width: 180px;
}
@media (max-width: 1350px) {
  .manuals-wrapper .table-container {
    padding: 0 !important;
    width: 100%;
  }
  .manuals-wrapper .table-container .archived-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    gap: 12px;
  }
  .manuals-wrapper .table-container .archived-wrapper > p {
    margin: auto;
  }
  .manuals-wrapper .table-container .archived-image {
    margin: 0;
  }
  .manuals-wrapper .table-container thead {
    display: none;
  }
  .manuals-wrapper .table-container .no-item {
    min-width: 0;
  }
  .manuals-wrapper .table-container .no-item ul {
    margin: 1rem 0 0;
  }
  .manuals-wrapper .table-container .manual-content-wrapper {
    border: 0;
  }
  .manuals-wrapper .table-container .manual-content-wrapper tr {
    display: block;
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px;
  }
  .manuals-wrapper .table-container .manual-content-wrapper td,
  .manuals-wrapper .table-container .manual-content-wrapper th {
    display: block;
    text-align: center;
    border: 0;
    padding: 8px;
    position: relative;
  }
  .manuals-wrapper .table-container .manual-content-wrapper td:last-child {
    margin-bottom: 0;
  }
  .manuals-wrapper .table-container .manual-content-wrapper td a {
    text-decoration: none;
    color: #007bff;
  }
  .manuals-wrapper .table-container .manual-content-wrapper td a:hover {
    text-decoration: underline;
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/manuals/manuals.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,yCAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AACJ;AAEI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAAN;AAEM;EACE,SAAA;EACA,mBAAA;AAAR;AAGM;EACE,SAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AADR;AAGQ;EAPF;IAQI,cAAA;EAAR;AACF;AAEQ;EACE,aAAA;EACA,mBAAA;AAAV;AAEU;EAJF;IAKI,sBAAA;EACV;AACF;AAEY;EADF;IAEI,UAAA;IACA,iBAAA;EACZ;AACF;AAEU;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAAZ;AAEY;EARF;IASI,SAAA;IACA,WAAA;EACZ;AACF;AAME;EACE,iBAAA;EAEA,aAAA;EACA,SAAA;AALJ;AAQE;EACE;IACE,oBAAA;IACA,mBAAA;EANJ;AACF;AASE;EACE;IACE,oBAAA;EAPJ;EAUE;IACE,mBAAA;EARJ;AACF;AAWE;EACE;IACE,iCAAA;IACA,mBAAA;EATJ;EAYE;IACE,cAAA;EAVJ;EAaE;IACE,0BAAA;EAXJ;EAcE;IACE,6BAAA;EAZJ;AACF;AAeE;EACE,YAAA;EACA,YAAA;AAbJ;AAgBE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AAdJ;AAgBI;EACE,gBAAA;EACA,YAAA;AAdN;AAiBI;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AAfN;AAiBM;;EAEE,kBAAA;EACA,yBAAA;AAfR;AAkBM;EACE,yBAAA;AAhBR;AAoBQ;EACE,6BAAA;EACA,UAAA;AAlBV;AAqBQ;EACE,UAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;AAnBV;AAsBQ;EACE,gBAAA;AApBV;AAwBU;EACE,mBAAA;AAtBZ;AAwBY;EACE,cAAA;EACA,0BAAA;AAtBd;AA0BU;EACE,iBAAA;AAxBZ;AA2BU;EACE,WAAA;AAzBZ;AA+BI;EACE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA9BN;AAiCM;EACE,kBAAA;EACA,kBAAA;AA/BR;AAkCM;EACE,kBAAA;AAhCR;AAoCI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAlCN;AAsCI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AApCN;AAuCI;EACE,gBAAA;AArCN;AAyCI;EA1GF;IA2GI,qBAAA;IACA,WAAA;EAtCJ;EAwCI;IACE,aAAA;IACA,2BAAA;IACA,sBAAA;IACA,SAAA;EAtCN;EAwCM;IACE,YAAA;EAtCR;EA0CI;IACE,SAAA;EAxCN;EA4CI;IACE,aAAA;EA1CN;EA6CI;IACE,YAAA;EA3CN;EA6CO;IACE,gBAAA;EA3CT;EA+CI;IACE,SAAA;EA7CN;EA+CM;IACE,cAAA;IACA,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,YAAA;EA7CR;EAgDM;;IAEE,cAAA;IACA,kBAAA;IACA,SAAA;IACA,YAAA;IACA,kBAAA;EA9CR;EAiDM;IACE,gBAAA;EA/CR;EAkDM;IACE,qBAAA;IACA,cAAA;EAhDR;EAmDM;IACE,0BAAA;EAjDR;AACF","sourcesContent":[".manuals-wrapper {\n  padding-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n\n  .search-bar-wrapper {\n    background-color: var(--background-color);\n    padding: 30px 0;\n    right: 50%;\n    left: 50%;\n    display: flex;\n    text-align: center;\n\n\n    .search-bar-components {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      margin: 30px auto;\n\n      .rich-text__heading {\n        margin: 0;\n        padding: 20px 0 0 0;\n      }\n\n      .caliber-search-code {\n        margin: 0;\n        align-items: center;\n        display: flex;\n        flex-direction: column;\n        padding-top: 10px;\n\n        @media (max-width: 550px) {\n          margin: 0 25px;\n        }\n\n        .filter-wrapper {\n          display: flex;\n          flex-direction: row;\n\n          @media (max-width: 550px) {\n            flex-direction: column;\n          }\n\n          button {\n            @media (max-width: 550px) {\n              width: 50%;\n              margin: 20px auto;\n            }\n          }\n\n          input {\n            padding: 16px;\n            height: 50px;\n            background: transparent;\n            font-size: 16px;\n            width: 300px;\n            margin-right: 10px;\n\n            @media (max-width: 550px) {\n              margin: 0;\n              width: 100%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .manuals-container {\n    padding: 12px 0 0;\n\n    display: flex;\n    gap: 36px;\n  }\n\n  @media (min-width: 551px) and (max-width: 768px) {\n    .manuals-container {\n      gap: 16px !important;\n      align-items: center;\n    }\n  }\n\n  @media (max-width: 1350px) {\n    .manuals-container {\n      gap: 24px !important;\n    }\n\n    .search-bar-wrapper .search-bar-components {\n      margin: 30px auto 0;\n    }\n  }\n\n  @media only screen and (max-width: 768px) {\n    .manuals-container {\n      flex-direction: column !important;\n      align-items: center;\n    }\n\n    .manuals-container button {\n      margin: 0 auto\n    }\n\n    .manuals-header {\n      padding: 0 25px !important;\n    }\n\n    .manuals-wrapper .search-bar-wrapper {\n      padding: 24px 40px !important;\n    }\n  }\n\n  #searchBar {\n    width: 350px;\n    height: 50px;\n  }\n\n  .table-container {\n    margin: 0 auto;\n    width: min-content;\n    padding: 50px 0px;\n\n    .manuals-text-description {\n      text-align: left;\n      height: 24px;\n    }\n\n    table {\n      width: 100%;\n      font-weight: 500;\n      border-collapse: collapse;\n\n      th,\n      td {\n        padding: 12px 16px;\n        border: 1px solid #e6e6e6;\n      }\n\n      thead {\n        background-color: #f0f0f0;\n      }\n\n      tbody {\n        tr {\n          transition: opacity 0.5s ease;\n          opacity: 1;\n        }\n\n        tr.hidden {\n          opacity: 0;\n          display: none;\n          height: 0;\n          overflow: hidden;\n        }\n\n        th {\n          text-align: left;\n        }\n\n        td {\n          .manual-wrapper {\n            padding-bottom: 7px;\n\n            a {\n              color: #193c72;\n              text-decoration: underline;\n            }\n          }\n\n          .manual-wrapper:last-child {\n            padding-bottom: 0;\n          }\n\n          .manual-button {\n            width: 100%;\n          }\n        }\n      }\n    }\n\n    .no-item {\n      margin: auto;\n      padding: 1.5rem;\n      border: 1px solid #e6e6e6;\n      text-align: center;\n      min-width: 980px;\n\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n\n\n      ul {\n        width: fit-content;\n        margin: 1.5rem 0 0;\n      }\n\n      li {\n        width: fit-content;\n      }\n    }\n\n    .archived-wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      flex-direction: row;\n\n    }\n\n    .archived-image {\n      max-height: 40px;\n      display: block;\n      margin-top: 5px;\n      margin-right: 15px;\n    }\n\n    .manual-button {\n      min-width: 180px;\n    }\n\n\n    @media (max-width: 1350px) {\n      padding: 0 !important;\n      width: 100%;\n\n      .archived-wrapper {\n        display: flex;\n        justify-content: flex-start;\n        flex-direction: column;\n        gap: 12px;\n\n        > p {\n          margin: auto;\n        }\n      }\n\n      .archived-image {\n        margin: 0;\n      }\n\n\n      thead {\n        display: none;\n      }\n\n      .no-item {\n        min-width: 0;\n\n         ul {\n           margin: 1rem 0 0;\n         }\n      }\n\n      .manual-content-wrapper {\n        border: 0;\n\n        tr {\n          display: block;\n          margin-bottom: 1rem;\n          border: 1px solid #ddd;\n          border-radius: 8px;\n          padding: 8px;\n        }\n\n        td,\n        th {\n          display: block;\n          text-align: center;\n          border: 0;\n          padding: 8px;\n          position: relative;\n        }\n\n        td:last-child {\n          margin-bottom: 0;\n        }\n\n        td a {\n          text-decoration: none;\n          color: #007bff;\n        }\n\n        td a:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
